import { formatDateKey } from './date';
import { getCelebrations } from './holidays';

export function getStats(year: number, monthIndex: number, includeSaturday: boolean) {
  const holidays = getCelebrations(year);
  const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();

  let workdays = 0;
  let workHours = 0;
  let celebrationCount = 0;

  for (let d = 1; d <= daysInMonth; d++) {
    const date = new Date(year, monthIndex, d);
    const key = formatDateKey(date);
    const dow = date.getDay();

    const isOfficialHoliday = holidays.has(key);
    if (isOfficialHoliday) celebrationCount++;

    const isWeekend = dow === 0 || (!includeSaturday && dow === 6);
    if (isOfficialHoliday || isWeekend) continue;

    workdays++;

    let baseHours = 0;
    if (includeSaturday) {
      if (dow >= 1 && dow <= 5) baseHours = 7;
      else if (dow === 6) baseHours = 5;
    } else {
      baseHours = 8;
    }

    const nextDay = new Date(year, monthIndex, d + 1);
    const nextKey = formatDateKey(nextDay);
    if (holidays.has(nextKey)) baseHours -= 1;

    workHours += Math.max(0, baseHours);
  }

  return { workdays, workHours, celebrationCount };
}